export default __webpack_public_path__ + "static/media/BodyPart_02.db8c2688.png";